import { useState } from 'react';
import Modal from '../shared/Modal';
import { addTeamMember } from '../../utils/api';

export default function AddPersonToRosterModal({
  open, onClose, teamId, allPeople, onAdd, onAddNewPerson, showToast,
}) {
  const [query, setQuery] = useState('');
  const [selected, setSelected] = useState(null);

  const results = query.length > 1
    ? (allPeople || []).filter(p =>
        (p.name || '').toLowerCase().includes(query.toLowerCase()) ||
        (p.email || '').toLowerCase().includes(query.toLowerCase())
      ).slice(0, 8)
    : [];

  function reset() { setQuery(''); setSelected(null); }

  function handleAdd() {
    if (!selected) return;

    // Build synthetic member object for instant UI update
    const member = {
      id: crypto.randomUUID(),
      teamId,
      personId: selected.id,
      role: 'member',
      createdAt: new Date().toISOString(),
    };

    showToast(`${selected.name} added to roster.`);
    reset();
    onClose();
    if (onAdd) onAdd(member);

    // Persist in background
    addTeamMember(teamId, selected.id, 'member').catch(err => {
      showToast('Error adding person to roster — please refresh.');
      console.error(err);
    });
  }

  function handleAddNew() {
    reset();
    onClose();
    if (onAddNewPerson) onAddNewPerson();
  }

  return (
    <Modal
      open={open}
      onClose={() => { reset(); onClose(); }}
      title="Add Person to Roster"
      footer={
        <>
          <button className="btn" onClick={() => { reset(); onClose(); }}>Cancel</button>
          <button className="btn btn-dark" onClick={handleAdd} disabled={!selected}>
            Add to Roster
          </button>
        </>
      }
    >
      <div className="form-group">
        <label className="form-label">Search By Name or Email</label>
        <div className="search-dropdown">
          <input
            className="form-input"
            placeholder="Type a name or email…"
            value={query}
            onChange={e => { setQuery(e.target.value); setSelected(null); }}
            autoComplete="off"
          />
          {query.length > 1 && (
            <div className="search-results">
              {results.map(p => (
                <div key={p.id} className="search-result-item" onClick={() => { setSelected(p); setQuery(''); }}>
                  <div className="search-result-name">{p.name}</div>
                  <div className="search-result-meta">
                    {p.email}{p.brushfireId ? ' · Registered' : ' · Not Registered'}
                  </div>
                </div>
              ))}
              <div className="search-result-item" onClick={handleAddNew}>
                <div className="search-result-name">+ Add new person manually</div>
                <div className="search-result-meta">They'll appear on your roster as Not Yet Registered</div>
              </div>
            </div>
          )}
        </div>
      </div>

      {selected && (
        <div style={{ background: 'var(--off)', border: '1px solid var(--border)', borderRadius: 'var(--radius)', padding: 14, marginTop: -8 }}>
          <div style={{ fontFamily: 'var(--font-h)', fontSize: 14, fontWeight: 800, color: 'var(--black)' }}>{selected.name}</div>
          <div style={{ fontFamily: 'var(--font-b)', fontSize: 13, fontWeight: 300, color: 'var(--muted)', marginTop: 3 }}>
            {selected.email}{selected.brushfireId ? ' · Registered' : ' · Not Registered'}
          </div>
        </div>
      )}

      <div style={{ marginTop: 20, borderTop: '1px solid var(--border)', paddingTop: 16, textAlign: 'center' }}>
        <span style={{ fontFamily: 'var(--font-b)', fontSize: 12, fontWeight: 300, color: 'var(--muted)', marginRight: 10 }}>
          Person not in system yet?
        </span>
        <button className="btn btn-sm" onClick={handleAddNew}>+ Add New Person Manually</button>
      </div>
    </Modal>
  );
}
